import React, { useState } from "react";
import { PageHeader, Button, Popover, Input } from "antd";
import BackArrow from "../../assets/BackArrow.svg";
import BackArrowWhite from "../../assets/WhiteIcons/BackArrow_White.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  setCreateWidget,
  setUpdateImpression,
  setWidgetLibraryList,
  setWidgetMakerGraphData,
  setWidgetPreview,
  setWidgetPreviewLoader,
} from "../../redux/actions/WidgetMaker/WidgetAPI";
import {
  deepCopy,
  getCustomizedDate,
  getPaneIndex,
  getTemplateListBasicObject,
  getWidgetLibraryListObject,
  removeHiddenFromSaved,
  removePrivateConversationFilters,
  updateChartSettingsInGraphObjectBasedOnSelection,
} from "../../redux/constants";
import moment from "moment";
import {
  setWidgetChartDescription,
  setWidgetChartName,
  setWidgetTags,
  setX_attribute,
  setY_attribute,
} from "../../redux/actions/WidgetMaker/GraphConfig";
import uuid from "react-uuid";
import {
  setEditWidget,
  setWidgetLibraryFilter,
  setWidgetShow,
} from "../../redux/actions/WidgetMaker/WidgetLibrary";
import { useHistory, useParams } from "react-router-dom";
import { useEffect } from "react";
import { setIsDuplicate } from "../../redux/actions/WidgetMaker/WidgetMaker";
import {
  setFilterPanelData,
  setisFilterPanelVisible,
} from "../../redux/actions/Filter";
import AlertModal from "./AlertModal";
import TagsInput from "react-tagsinput";
import { setDuplicateTemplate } from "../../redux/actions/ApiCall/apiCall";
import {
  setIsWidgetMakerOpenObj,
  setSelectedPillInPane,
} from "../../redux/actions/dashboard/Tab1";
import ExitModal from "./ExitModal";
import isEqual from "react-fast-compare";
import { supportedBenchmarkTraceChartTypes } from "../../redux/constants/enums";

const { TextArea } = Input;
const WidgetMakerHeader = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const [flag, setflag] = useState(false);
  const [widgetName, setWidgetName] = useState("");
  const authParams = useSelector((state) => state.Authentication.authParams);
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const data_source = useSelector((state) => state.WidgetLibrary.data_source);
  const filterData = useSelector((state) => state.Filter.filterPanelData);

  const isEditWidget = useSelector((state) => state.WidgetLibrary.editWidget);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const chartName = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig?.chart_property?.chart_name
  );
  const chartDescription = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig?.widget_description
  );
  const widgetTag = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig?.tags
  );
  const widgetMakerGraphData1 = useSelector(
    (state) => state?.WidgetAPI?.widget_maker_graph_data
  );
  const widgetLibraryFilter = useSelector(
    (state) => state?.WidgetLibrary?.widgetLibraryFilter
  );
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  let index = getPaneIndex(panes, activeKey);

  const Allbrands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const global_dashboard_duration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const temporary_words = useSelector(
    (state) => state.attributes.temporary_words
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const chartLoader = useSelector((state) => state?.WidgetAPI?.chart_loader);

  const [enableSave, setEnableSave] = useState(false);
  const [description, setdescription] = useState(
    widgetGraphConfig?.widget_description
      ? widgetGraphConfig?.widget_description
      : null
  );
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [openExitModal, setOpenExitModal] = useState(false);

  useEffect(() => {
    if (widgetGraphConfig?.widget_description) {
      setdescription(widgetGraphConfig?.widget_description);
    }

    let pivot_index = widgetGraphConfig?.breakdown_by?.findIndex(
      (d) => d?.is_pivot
    );
    if (widgetGraphConfig?.chart_type === "prolific-user") {
      widgetGraphConfig?.order_by ? setEnableSave(true) : setEnableSave(false);
    } else if (
      widgetGraphConfig?.chart_type === "post-card" ||
      widgetGraphConfig?.chart_type === "survey-card"
    ) {
      widgetGraphConfig?.order_by?.attribute ||
      widgetGraphConfig?.order_by?.offset ||
      widgetGraphConfig?.filter_by?.attribute
        ? setEnableSave(true)
        : setEnableSave(false);
    } else if (widgetGraphConfig?.chart_type === "news-card") {
      widgetGraphConfig?.order_by?.attribute ||
      widgetGraphConfig?.order_by?.offset
        ? setEnableSave(true)
        : setEnableSave(false);
    } else if (widgetGraphConfig?.chart_type === "review-card") {
      widgetGraphConfig?.order_by?.attribute
        ? setEnableSave(true)
        : setEnableSave(false);
    } else if (widgetGraphConfig?.chart_type === "author-card") {
      widgetGraphConfig?.order_by?.attribute
        ? setEnableSave(true)
        : setEnableSave(false);
    }
    if (
      widgetGraphConfig?.chart_type === "combination" ||
      widgetGraphConfig?.chart_type === "scatter"
    ) {
      widgetGraphConfig?.x_axis &&
      widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
      widgetGraphConfig?.y_axis?.y_series_2?.attribute
        ? setEnableSave(true)
        : setEnableSave(false);
    } else if (
      widgetGraphConfig?.chart_type === "bubble" ||
      widgetGraphConfig?.chart_type === "heatmap" ||
      widgetGraphConfig?.chart_type === "sunburst"
    ) {
      widgetGraphConfig?.x_axis &&
      widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
      widgetGraphConfig?.breakdown_by?.[0]?.attribute
        ? setEnableSave(true)
        : setEnableSave(false);
    } else if (widgetGraphConfig?.chart_type === "sankey") {
      widgetGraphConfig?.x_axis &&
      widgetGraphConfig?.y_axis?.y_series_1?.attribute
        ? setEnableSave(true)
        : setEnableSave(false);
    } else if (
      widgetGraphConfig?.chart_type === "pie" ||
      widgetGraphConfig?.chart_type === "donut" ||
      widgetGraphConfig?.chart_type === "wordcloud" ||
      widgetGraphConfig?.chart_type === "line" ||
      widgetGraphConfig?.chart_type === "bar" ||
      widgetGraphConfig?.chart_type === "horizontal-bar" ||
      widgetGraphConfig?.chart_type === "lollipop" ||
      widgetGraphConfig?.chart_type === "area" ||
      widgetGraphConfig?.chart_type === "quadrant" || // newly added
      widgetGraphConfig?.chart_type === "multilayer-map" || // newly added
      widgetGraphConfig?.chart_type === "treemap"
    ) {
      widgetGraphConfig?.x_axis &&
      widgetGraphConfig?.y_axis?.y_series_1?.attribute
        ? setEnableSave(true)
        : setEnableSave(false);
    } else if (widgetGraphConfig?.chart_type === "map") {
      widgetGraphConfig?.y_axis?.y_series_1?.attribute
        ? setEnableSave(true)
        : setEnableSave(false);
    } else if (
      widgetGraphConfig?.chart_type === "grid" ||
      widgetGraphConfig?.chart_type === "network-graph" ||
      widgetGraphConfig?.chart_type === "network-graph-v2" ||
      widgetGraphConfig?.chart_type === "cluster-chart"
    ) {
      widgetGraphConfig?.x_axis &&
      widgetGraphConfig?.y_axis?.y_series_1?.attribute
        ? setEnableSave(true)
        : setEnableSave(false);
    } else if (widgetGraphConfig?.chart_type === "rich-text") {
      // For rich-text, we only need rich_fields to consider it ready
      (widgetGraphConfig?.x_axis?.attribute ||
        (widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
          !widgetGraphConfig?.y_axis?.y_series_1?.hide_on_ui)) &&
      widgetGraphConfig?.rich_fields_content
        ? setEnableSave(true)
        : setEnableSave(false);
    } else if (
      widgetGraphConfig?.chart_type === "kpi" ||
      widgetGraphConfig?.chart_type === "progress-kpi"
    ) {
      widgetGraphConfig?.x_axis ||
      widgetGraphConfig?.y_axis?.y_series_1?.attribute
        ? setEnableSave(true)
        : setEnableSave(false);
    } else if (widgetGraphConfig?.chart_type === "pivot-grid") {
      widgetGraphConfig?.x_axis &&
      widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
      widgetGraphConfig?.breakdown_by?.length > 0 &&
      pivot_index > -1
        ? setEnableSave(true)
        : setEnableSave(false);
    }
  }, [widgetGraphConfig]);

  useEffect(() => {
    if (!flag && widgetGraphConfig?.chart_property?.chart_name) {
      setWidgetName(widgetGraphConfig?.chart_property?.chart_name);
    } else {
      setWidgetName("");
    }
  }, [widgetGraphConfig]);

  const widgetMakerGraphData =
    typeof widgetMakerGraphData1 === "string"
      ? widgetMakerGraphData1
      : widgetMakerGraphData1?.data?.[
          widgetGraphConfig?.chart_type === "combination"
            ? "combination"
            : widgetGraphConfig?.chart_type === "horizontal-bar"
            ? "bar"
            : widgetGraphConfig?.chart_type === "donut"
            ? "pie"
            : widgetGraphConfig?.chart_type
        ];

  // To Save Widget of Widget Maker
  const handleSaveWidget = () => {
    let pathName = window.location.pathname?.split("/")?.[1];
    if (
      pathName === "dashboard" ||
      pathName === "pin-dashboard" ||
      pathName === "all-dashboard"
    ) {
      // Close the Filter Drawer pannel
      dispatch(setisFilterPanelVisible(false));

      // console.log("panes save me", panes?.[index]);
      let section_index =
        panes?.[index]?.is_widget_maker_open_obj?.section_index;
      let widget_index = panes?.[index]?.is_widget_maker_open_obj?.widget_index;

      let updatePanes = [...panes];
      if (section_index >= 0) {
        let y_series_array = [];
        y_series_array = Object.keys(widgetGraphConfig?.y_axis).map(
          (key) => widgetGraphConfig?.y_axis[key]
        );
        y_series_array = y_series_array?.filter((e) => e?.attribute);
        let card_settings_data = [];
        widgetGraphConfig?.card_settings?.map((d) => {
          if (d?.x_axis || (d?.x_axis == null && d?.y_series)) {
            card_settings_data = [
              ...card_settings_data,
              {
                x_axis:
                  d?.x_axis == null
                    ? null
                    : Object.keys(d?.x_axis).length == 0
                    ? null
                    : {
                        ...d?.x_axis,
                        trace_name: d?.x_axis?.trace_name
                          ? d?.x_axis?.trace_name
                          : All_WM_attributes[
                              d?.x_axis?.attribute?.toLowerCase()
                            ] +
                            " With " +
                            All_WM_attributes[
                              d?.y_series?.attribute?.toLowerCase()
                            ],
                      },
                y_series: d?.y_series,
              },
            ];
          }
        });

        let updatedOrderBy;
        if (widgetGraphConfig?.order_by) {
          updatedOrderBy = {
            ...widgetGraphConfig?.order_by,
            offset: 0,
          };
        }

        let chart = {
          chart_type: widgetGraphConfig?.chart_type,
          rich_fields_content: widgetGraphConfig?.rich_fields_content,
          chart_settings: {
            ...widgetGraphConfig?.chart_settings,
            grid_config: widgetGraphConfig?.chart_settings?.grid_config,
            show_3d: widgetGraphConfig?.chart_settings?.show_3d,
            settings_3d: widgetGraphConfig?.chart_settings?.settings_3d,
            duration_comparison:
              widgetGraphConfig?.chart_settings?.duration_comparison,
            show_previous_duration_comparison:
              widgetGraphConfig?.chart_settings
                ?.show_previous_duration_comparison,
            show_previous_duration_data:
              widgetGraphConfig?.chart_settings?.show_previous_duration_data,
            show_data_labels: widgetGraphConfig?.chart_settings
              ?.global_data_label
              ? widgetGraphConfig?.chart_settings?.global_data_label
              : false,
            show_details_on_card: widgetGraphConfig?.chart_settings
              ?.show_details_on_card
              ? widgetGraphConfig?.chart_settings?.show_details_on_card
              : false,
            show_as_median: widgetGraphConfig?.chart_settings?.show_as_median
              ? widgetGraphConfig?.chart_settings?.show_as_median
              : false, // this is used for scatter chart
            duplicate_for_brands: widgetGraphConfig?.chart_settings
              ?.duplicate_for_brands
              ? widgetGraphConfig?.chart_settings?.duplicate_for_brands
              : false,
            is_stacked: widgetGraphConfig?.chart_settings?.is_stacked,
            show_count_cards:
              widgetGraphConfig?.chart_settings?.data_count_card,
            card_percent: widgetGraphConfig?.chart_settings?.card_percent, //	card_percent is share of data
            chart_percent: widgetGraphConfig?.chart_settings?.chart_percent,
            gradient_color: widgetGraphConfig?.chart_settings?.gradient_color,
            total_row: widgetGraphConfig?.chart_settings?.total_row,
            split_cards: widgetGraphConfig?.chart_settings?.split_cards,
            wordcloud_color: widgetGraphConfig?.chart_settings?.wordcloud_color,
            top_posts_in_cards:
              widgetGraphConfig?.chart_settings?.top_posts_in_cards,
            show_header:
              typeof widgetGraphConfig?.chart_settings?.show_header ===
              "boolean"
                ? widgetGraphConfig?.chart_settings?.show_header
                : true,
            chart_property: {
              chart_name: widgetGraphConfig?.chart_property?.chart_name,
              legend_position:
                widgetGraphConfig?.chart_property?.legend_position,
              y_axis_mode: widgetGraphConfig?.chart_property?.y_axis_mode,
              no_of_top_posts:
                widgetGraphConfig?.chart_property?.no_of_top_posts,
              show_legend: widgetGraphConfig?.chart_property?.show_legend,
            },
            show_marker: widgetGraphConfig?.show_marker,
            card_position: widgetGraphConfig?.card_position,
            card_limit: widgetGraphConfig?.card_limit,
            y_axes_settings: widgetGraphConfig?.y_axis_settings,
            cards_settings: card_settings_data ? card_settings_data : null,
            show_peak: widgetGraphConfig?.chart_settings?.show_peak,
            show_valley: widgetGraphConfig?.chart_settings?.show_valley,
            chart_styles:
              widgetGraphConfig?.chart_settings?.chart_styles || null,
            cluster_style: widgetGraphConfig?.chart_settings?.cluster_style,
            cluster_chart_type:
              widgetGraphConfig?.chart_settings?.cluster_chart_type,
            total_count_flag:
              widgetGraphConfig?.chart_settings?.total_count_flag || false,
          },
        };
        // Section Case Start
        updatePanes[index].sections[section_index].widgets[widget_index].chart =
          chart;
        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].widget_name = chartName
          ? chartName
          : widgetGraphConfig?.chart_property?.chart_name;
        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].widget_description = chartDescription
          ? chartDescription
          : description;
        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].x_axis = widgetGraphConfig?.x_axis;
        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].y_axes =
          widgetGraphConfig?.breakdown_by?.length > 0
            ? widgetGraphConfig?.breakdown_by
            : widgetGraphConfig?.filter_by
            ? widgetGraphConfig?.filter_by
            : null;
        // for filter dropdown in widget header
        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].filter_dropdown =
          widgetGraphConfig?.filter_dropdown?.length > 0
            ? widgetGraphConfig?.filter_dropdown
            : [];
        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].filter_by_dropdown = [];
        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].filter_by_dropdown_data = [];
        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].multilevel_breakdown = widgetGraphConfig?.multilevel_breakdown;

        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].order_by = updatedOrderBy ? updatedOrderBy : null;
        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].y_series = widgetGraphConfig?.order_by ? null : y_series_array;
        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].filters = widgetGraphConfig?.filters
          ? widgetGraphConfig?.filters
          : null;
        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].data_source =
          data_source === "page"
            ? "mentions"
            : data_source
            ? data_source
            : "mentions";

        // For Section Level Logical brands (Lock and Non-Lock)
        if (updatePanes[index].sections[section_index]?.brand_groups) {
          updatePanes[index].sections[section_index].brands =
            updatePanes[index].sections[section_index]?.brand_groups;

          if (
            !updatePanes?.[index].sections[section_index].brandFilters ||
            updatePanes[index].sections[section_index].brandFilters?.length ===
              0
          ) {
            let updatedColumns = [];
            updatedColumns = updatePanes[index].sections[
              section_index
            ]?.brand_groups?.map((d) => {
              if (!d?.group) {
                d.group = true;
              }
              return d;
            });

            let brandArray = [
              {
                attribute: "BrandID",
                columns: updatedColumns,
                type: "varchar",
              },
            ];
            updatePanes[index].sections[section_index].brandFilters =
              brandArray;
          }
        }
        // For Section Level Single brands (Lock and Non-Lock)
        if (updatePanes[index].sections[section_index]?.brand_ids) {
          updatePanes[index].sections[section_index].brands =
            updatePanes[index].sections[section_index]?.brand_ids;

          if (
            !updatePanes?.[index].sections[section_index].brandFilters ||
            updatePanes[index].sections[section_index].brandFilters?.length ===
              0
          ) {
            let singleBrandArray = [
              {
                attribute: "BrandID",
                columns: updatePanes[index].sections[section_index]?.brand_ids,
                type: "varchar",
              },
            ];
            updatePanes[index].sections[section_index].brandFilters =
              singleBrandArray;
          }
        }
        // For Section Level Duration (Lock and Non-Lock)
        if (updatePanes[index].sections[section_index]?.duration) {
          updatePanes[index].sections[section_index].duration =
            updatePanes[index].sections[section_index]?.duration;

          if (
            !updatePanes?.[index].sections[section_index].brandFilters ||
            updatePanes[index].sections[section_index].brandFilters?.length ===
              0
          ) {
            let durationObject = [
              {
                attribute: "createddate",
                columns: updatePanes[index].sections[section_index]?.duration,
                type: "datetime",
              },
            ];
            updatePanes[index].sections[section_index].brandFilters =
              durationObject;
          }
        }

        // For Widget Level Logical brands (Lock and Non-Lock)
        if (
          updatePanes[index].sections[section_index].widgets[widget_index]
            .brand_groups
        ) {
          updatePanes[index].sections[section_index].widgets[
            widget_index
          ].brands =
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].brand_groups;

          if (
            !updatePanes[index].sections[section_index].widgets[widget_index]
              .brandFilters ||
            updatePanes[index].sections[section_index].widgets[widget_index]
              .brandFilters?.length === 0
          ) {
            let updatedColumns = [];
            updatedColumns = updatePanes[index].sections[section_index].widgets[
              widget_index
            ]?.brand_groups?.map((d) => {
              if (!d?.group) {
                d.group = true;
              }
              return d;
            });

            let brandArray = [
              {
                attribute: "BrandID",
                columns: updatedColumns,
                type: "varchar",
              },
            ];
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].brandFilters = brandArray;
          }
        }
        // For Widget Level Single brands (Lock and Non-Lock)
        if (
          updatePanes[index].sections[section_index].widgets[widget_index]
            ?.brand_ids
        ) {
          updatePanes[index].sections[section_index].widgets[
            widget_index
          ].brands =
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ]?.brand_ids;

          if (
            !updatePanes[index].sections[section_index].widgets[widget_index]
              .brandFilters ||
            updatePanes[index].sections[section_index].widgets[widget_index]
              .brandFilters?.length === 0
          ) {
            let singleBrandArray = [
              {
                attribute: "BrandID",
                columns:
                  updatePanes[index].sections[section_index].widgets[
                    widget_index
                  ]?.brand_ids,
                type: "varchar",
              },
            ];
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].brandFilters = singleBrandArray;
          }
        }
        // For Widget Level Duration (Lock and Non-Lock)
        if (
          updatePanes[index].sections[section_index].widgets[widget_index]
            ?.duration
        ) {
          updatePanes[index].sections[section_index].widgets[
            widget_index
          ].duration =
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ]?.duration;

          if (
            !updatePanes[index].sections[section_index].widgets[widget_index]
              .brandFilters ||
            updatePanes[index].sections[section_index].widgets[widget_index]
              .brandFilters?.length === 0
          ) {
            let durationObject = [
              {
                attribute: "createddate",
                columns:
                  updatePanes[index].sections[section_index].widgets[
                    widget_index
                  ]?.duration,
                type: "datetime",
              },
            ];
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].brandFilters = durationObject;
          }
        }

        // Make Brands null
        // updatePanes[index].sections[section_index].widgets[
        //   widget_index
        // ].brand_groups = null;
        // updatePanes[index].sections[section_index].widgets[
        //   widget_index
        // ].brand_ids = null;

        function compareObjects(obj1, obj2) {
          const areEqual = isEqual(obj1, obj2);
          if (areEqual) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].is_widget_edited = false;
            if (!panes?.[index]?.is_dashboard_edited) {
              updatePanes[index].is_dashboard_edited = false;
            }
          } else {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].is_widget_edited = true;
            updatePanes[index].is_dashboard_edited = true;

            // if (authParams?.template_id || pathName === "pin-dashboard") {
            // Pass Message to angular side for edit widget in dashboard feature
            window.parent.postMessage(
              {
                is_edited_dashboard_flag: true,
                message: "is_edited_dashboard_msg",
              },
              "*"
            );
            // }
          }
        }

        compareObjects(
          widgetGraphConfig,
          panes?.[index]?.edited_widgetGraphConfig
        );

        // Section Case End

        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].graphData = null;

        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].persist_graphdata = null;

        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].deep_dive_on = null;

        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].graph_type = widgetGraphConfig?.chart_type;

        let obj = {
          open_flag: false,
          section_index: null,
          widget_index: null,
        };
        updatePanes[index].is_widget_maker_open_obj = obj;
        // updatePanes[index].is_dashboard_edited = true;
        updatePanes[index].edited_widgetGraphConfig = null;
      } else {
        let y_series_array = [];
        y_series_array = Object.keys(widgetGraphConfig?.y_axis).map(
          (key) => widgetGraphConfig?.y_axis[key]
        );
        y_series_array = y_series_array?.filter((e) => e?.attribute);
        let card_settings_data = [];
        widgetGraphConfig?.card_settings?.map((d) => {
          if (d?.x_axis || (d?.x_axis == null && d?.y_series)) {
            card_settings_data = [
              ...card_settings_data,
              {
                x_axis:
                  d?.x_axis == null
                    ? null
                    : Object.keys(d?.x_axis).length == 0
                    ? null
                    : {
                        ...d?.x_axis,
                        trace_name: d?.x_axis?.trace_name
                          ? d?.x_axis?.trace_name
                          : All_WM_attributes[
                              d?.x_axis?.attribute?.toLowerCase()
                            ] +
                            " With " +
                            All_WM_attributes[
                              d?.y_series?.attribute?.toLowerCase()
                            ],
                      },
                y_series: d?.y_series,
              },
            ];
          }
        });

        let updatedOrderBy;
        if (widgetGraphConfig?.order_by) {
          updatedOrderBy = {
            ...widgetGraphConfig?.order_by,
            offset: 0,
          };
        }

        let chart = {
          chart_type: widgetGraphConfig?.chart_type,
          rich_fields_content: widgetGraphConfig?.rich_fields_content,
          chart_settings: {
            ...widgetGraphConfig?.chart_settings,
            grid_config: widgetGraphConfig?.chart_settings?.grid_config,
            show_3d: widgetGraphConfig?.chart_settings?.show_3d,
            settings_3d: widgetGraphConfig?.chart_settings?.settings_3d,
            duration_comparison:
              widgetGraphConfig?.chart_settings?.duration_comparison,
            show_previous_duration_comparison:
              widgetGraphConfig?.chart_settings
                ?.show_previous_duration_comparison,
            show_previous_duration_data:
              widgetGraphConfig?.chart_settings?.show_previous_duration_data,
            show_data_labels: widgetGraphConfig?.chart_settings
              ?.global_data_label
              ? widgetGraphConfig?.chart_settings?.global_data_label
              : false,
            show_details_on_card: widgetGraphConfig?.chart_settings
              ?.show_details_on_card
              ? widgetGraphConfig?.chart_settings?.show_details_on_card
              : false,
            show_as_median: widgetGraphConfig?.chart_settings?.show_as_median
              ? widgetGraphConfig?.chart_settings?.show_as_median
              : false, // this is used for scatter chart
            duplicate_for_brands: widgetGraphConfig?.chart_settings
              ?.duplicate_for_brands
              ? widgetGraphConfig?.chart_settings?.duplicate_for_brands
              : false,
            is_stacked: widgetGraphConfig?.chart_settings?.is_stacked,
            show_count_cards:
              widgetGraphConfig?.chart_settings?.data_count_card,
            card_percent: widgetGraphConfig?.chart_settings?.card_percent, //	card_percent is share of data
            chart_percent: widgetGraphConfig?.chart_settings?.chart_percent,
            gradient_color: widgetGraphConfig?.chart_settings?.gradient_color,
            total_row: widgetGraphConfig?.chart_settings?.total_row,
            split_cards: widgetGraphConfig?.chart_settings?.split_cards,
            wordcloud_color: widgetGraphConfig?.chart_settings?.wordcloud_color,
            top_posts_in_cards:
              widgetGraphConfig?.chart_settings?.top_posts_in_cards,
            show_header:
              typeof widgetGraphConfig?.chart_settings?.show_header ===
              "boolean"
                ? widgetGraphConfig?.chart_settings?.show_header
                : true,
            chart_property: {
              chart_name: widgetGraphConfig?.chart_property?.chart_name,
              legend_position:
                widgetGraphConfig?.chart_property?.legend_position,
              y_axis_mode: widgetGraphConfig?.chart_property?.y_axis_mode,
              no_of_top_posts:
                widgetGraphConfig?.chart_property?.no_of_top_posts,
              show_legend: widgetGraphConfig?.chart_property?.show_legend,
            },
            show_marker: widgetGraphConfig?.show_marker,
            card_position: widgetGraphConfig?.card_position,
            card_limit: widgetGraphConfig?.card_limit,
            y_axes_settings: widgetGraphConfig?.y_axis_settings,
            cards_settings: card_settings_data ? card_settings_data : null,
            show_peak: widgetGraphConfig?.chart_settings?.show_peak,
            show_valley: widgetGraphConfig?.chart_settings?.show_valley,
            chart_styles:
              widgetGraphConfig?.chart_settings?.chart_styles || null,
            cluster_style: widgetGraphConfig?.chart_settings?.cluster_style,
            cluster_chart_type:
              widgetGraphConfig?.chart_settings?.cluster_chart_type,
            total_count_flag:
              widgetGraphConfig?.chart_settings?.total_count_flag || false,
          },
        };
        // Non Section Case Start
        updatePanes[index].section[0].widgets[widget_index].chart = chart;
        updatePanes[index].section[0].widgets[widget_index].widget_name =
          chartName ? chartName : widgetGraphConfig?.chart_property?.chart_name;
        updatePanes[index].section[0].widgets[widget_index].widget_description =
          chartDescription ? chartDescription : description;
        updatePanes[index].section[0].widgets[widget_index].x_axis =
          widgetGraphConfig?.x_axis;
        updatePanes[index].section[0].widgets[widget_index].y_axes =
          widgetGraphConfig?.breakdown_by?.length > 0
            ? widgetGraphConfig?.breakdown_by
            : widgetGraphConfig?.filter_by
            ? widgetGraphConfig?.filter_by
            : null;
        // for filter dropdown in widget header
        updatePanes[index].section[0].widgets[widget_index].filter_dropdown =
          widgetGraphConfig?.filter_dropdown?.length > 0
            ? widgetGraphConfig?.filter_dropdown
            : [];
        updatePanes[index].section[0].widgets[widget_index].filter_by_dropdown =
          [];
        updatePanes[index].section[0].widgets[
          widget_index
        ].filter_by_dropdown_data = [];
        updatePanes[index].section[0].widgets[
          widget_index
        ].multilevel_breakdown = widgetGraphConfig?.multilevel_breakdown;

        updatePanes[index].section[0].widgets[widget_index].order_by =
          updatedOrderBy ? updatedOrderBy : null;
        updatePanes[index].section[0].widgets[widget_index].y_series =
          widgetGraphConfig?.order_by ? null : y_series_array;
        updatePanes[index].section[0].widgets[widget_index].filters =
          widgetGraphConfig?.filters ? widgetGraphConfig?.filters : null;
        updatePanes[index].section[0].widgets[widget_index].data_source =
          data_source === "page"
            ? "mentions"
            : data_source
            ? data_source
            : "mentions";
        // Non Section Case End

        // Make Brands null
        // updatePanes[index].section[0].widgets[widget_index].brand_groups = null;
        // updatePanes[index].section[0].widgets[widget_index].brand_ids = null;

        function compareObjects(obj1, obj2) {
          const areEqual = isEqual(obj1, obj2);
          if (areEqual) {
            updatePanes[index].section[0].widgets[
              widget_index
            ].is_widget_edited = false;
            if (!panes?.[index]?.is_dashboard_edited) {
              updatePanes[index].is_dashboard_edited = false;
            }
          } else {
            updatePanes[index].section[0].widgets[
              widget_index
            ].is_widget_edited = true;
            updatePanes[index].is_dashboard_edited = true;

            // if (authParams?.template_id || pathName === "pin-dashboard") {
            // Pass Message to angular side for edit widget in dashboard feature
            window.parent.postMessage(
              {
                is_edited_dashboard_flag: true,
                message: "is_edited_dashboard_msg",
              },
              "*"
            );
            // }
          }
        }

        compareObjects(
          widgetGraphConfig,
          panes?.[index]?.edited_widgetGraphConfig
        );

        updatePanes[index].section[0].widgets[widget_index].graphData = null;

        updatePanes[index].section[0].widgets[widget_index].persist_graphdata =
          null;

        updatePanes[index].section[0].widgets[widget_index].deep_dive_on = null;

        updatePanes[index].section[0].widgets[widget_index].graph_type =
          widgetGraphConfig?.chart_type;

        let obj = {
          open_flag: false,
          section_index: null,
          widget_index: null,
        };
        updatePanes[index].is_widget_maker_open_obj = obj;
        // updatePanes[index].is_dashboard_edited = true;
        updatePanes[index].edited_widgetGraphConfig = null;
      }

      // console.log("Save Widget updatePanes", updatePanes);
      dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });

      // Reset Widget GraphConfig
      dispatch(
        setY_attribute({
          x_axis: null,
          y_axis: {
            y_series_1: {
              attribute: null,
              aggregation: null,
            },
          },
          y_axis_settings: [],
          breakdown_by: [],
          filter_by: [],
          fields: [],
          chart_type: "line",
          duration: null,
          brands: null,
          filters: [],
          show_marker: true,
          card_position: "Top",
          card_limit: 5,
          card_settings: [
            {
              card_id: uuid(),
              card_name: 1,
              card_value: null,
              x_axis: null,
              y_series: null,
              response: [],
            },
          ],
          rich_fields_content: null,
          chart_settings: {
            global_data_label: false,
            show_details_on_card: false,
            is_stacked: true,
            data_count_card: true,
            duration_comparison: false, // This is used for only KPI
            show_previous_duration_comparison: false, // This is used for charts
            show_previous_duration_data: false, // This is used for charts
            show_as_median: false, // this is used for scatter chart
            card_percent: true,
            chart_percent: false,
            gradient_color: false,
            group_line_agg: null,
            benchmark_line: false,
            benchmark_static_value: null,
            duplicate_for_brands: false,
            split_cards: true,
            wordcloud_color: "0",
            top_posts_in_cards: false,
            show_header: true,
            show_peak: true,
            show_valley: true,
            chart_styles: null,
            cluster_style: null,
            cluster_chart_type: null,
            total_count_flag: false,
          },
          chart_property: {
            chart_name: null,
            legend_position: "bottom",
            show_legend: true,
            y_axis_mode: 2,
            no_of_top_posts: 1,
          },
          widget_description: null,
          dragDataType: {
            varchar: false,
            int: false,
            datetime: false,
            json: false,
          },
          edit_fields: {
            boolValue: false,
            series: "",
            data: "",
          },
          order_by: null,
          custom_attribute: {
            name: null,
            description: null,
            formula: null,
            custom_column: [
              {
                parameters: {
                  attribute: null,
                  display_name: null,
                  data_type: null,
                  selected: true,
                },
                operator: { value: null, selected: false },
                pair: {
                  parameters: {
                    attribute: null,
                    display_name: null,
                    data_type: null,
                    selected: false,
                  },
                  numeric: { value: null, selected: false },
                },
                combined_operator: {
                  value: null,
                  selected: false,
                },
              },
            ],
          },
          widgetResetState: false,
          tags: [],
          filter_by_data: [],
          postcard_pills_filter: null,
          // for filter dropdown in widget header
          filter_dropdown: [],
          filter_by_dropdown: [],
          filter_by_dropdown_data: [],
          multilevel_breakdown: null,
        })
      );
    } else {
      let obj = {
        search_text: "",
        pill: "All Widgets",
        offset: 0,
        no_of_rows: 12,
        sort_expression: "created_date",
        sort_order: "desc",
        chart_type: "",
        attribute: "",
      };
      dispatch(setWidgetLibraryFilter(obj));
      if (typeof widgetMakerGraphData === "string") {
        setOpenAlertModal(true);
        setVisible(false);
        setflag(false);
      } else {
        let widget_obj = {
          isEditWidget,
          id,
        };
        const d = new Date();
        let utcOffset = d.getTimezoneOffset();
        let twoMonthsDuration = getCustomizedDate(6, "Days");
        let defaultDuration = {
          from:
            moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
            " " +
            twoMonthsDuration?.time?.startTime,
          to:
            moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
            " " +
            twoMonthsDuration?.time?.endTime,
        };
        let y_series_array = [];
        y_series_array = Object.keys(widgetGraphConfig?.y_axis).map(
          (key) => widgetGraphConfig?.y_axis[key]
        );
        y_series_array = y_series_array?.filter((e) => e?.attribute);
        let card_settings_data = [];
        widgetGraphConfig?.card_settings?.map((d) => {
          if (d?.x_axis || (d?.x_axis == null && d?.y_series)) {
            card_settings_data = [
              ...card_settings_data,
              {
                x_axis:
                  d?.x_axis == null
                    ? null
                    : Object.keys(d?.x_axis).length == 0
                    ? null
                    : {
                        ...d?.x_axis,
                        trace_name: d?.x_axis?.trace_name
                          ? d?.x_axis?.trace_name
                          : All_WM_attributes[d?.x_axis?.attribute] +
                            " With " +
                            All_WM_attributes[d?.y_series?.attribute],
                      },
                y_series: d?.y_series,
              },
            ];
          }
        });

        let updatedOrderBy;
        if (widgetGraphConfig?.order_by) {
          updatedOrderBy = {
            ...widgetGraphConfig?.order_by,
            offset: 0,
          };
        }

        let relative_duration = widgetGraphConfig?.duration?.save_as_relative
          ? {
              is_relative:
                widgetGraphConfig?.duration?.relative?.type === "short",
              relative_type:
                widgetGraphConfig?.duration?.relative?.value ?? null,
              // relative_days: widgetGraphConfig?.duration?.days ?? null,
              relative_days: null, // For now sending null
            }
          : null;

        let saveObject = {
          data_source: data_source,
          authParams: authParams,
          chart: {
            chart_type: widgetGraphConfig?.chart_type,
            rich_fields_content: widgetGraphConfig?.rich_fields_content,
            chart_settings: {
              grid_config: widgetGraphConfig?.chart_settings?.grid_config,
              duration_comparison:
                widgetGraphConfig?.chart_settings?.duration_comparison,
              show_previous_duration_comparison:
                widgetGraphConfig?.chart_settings
                  ?.show_previous_duration_comparison,
              show_previous_duration_data:
                widgetGraphConfig?.chart_settings?.show_previous_duration_data,
              show_data_labels: widgetGraphConfig?.chart_settings
                ?.global_data_label
                ? widgetGraphConfig?.chart_settings?.global_data_label
                : false,
              show_details_on_card: widgetGraphConfig?.chart_settings
                ?.show_details_on_card
                ? widgetGraphConfig?.chart_settings?.show_details_on_card
                : false,
              show_as_median: widgetGraphConfig?.chart_settings?.show_as_median
                ? widgetGraphConfig?.chart_settings?.show_as_median
                : false, // this is used for scatter chart
              show_label_names: widgetGraphConfig?.chart_settings
                ?.show_label_names
                ? widgetGraphConfig?.chart_settings?.show_label_names
                : false,
              duplicate_for_brands: widgetGraphConfig?.chart_settings
                ?.duplicate_for_brands
                ? widgetGraphConfig?.chart_settings?.duplicate_for_brands
                : false,
              is_stacked: widgetGraphConfig?.chart_settings?.is_stacked,
              show_count_cards:
                widgetGraphConfig?.chart_settings?.data_count_card,
              card_percent: widgetGraphConfig?.chart_settings?.card_percent, //	card_percent is share of data
              chart_percent: widgetGraphConfig?.chart_settings?.chart_percent,
              gradient_color: widgetGraphConfig?.chart_settings?.gradient_color,
              total_row: widgetGraphConfig?.chart_settings?.total_row,
              split_cards: widgetGraphConfig?.chart_settings?.split_cards,
              wordcloud_color:
                widgetGraphConfig?.chart_settings?.wordcloud_color,
              top_posts_in_cards:
                widgetGraphConfig?.chart_settings?.top_posts_in_cards,
              show_header:
                typeof widgetGraphConfig?.chart_settings?.show_header ===
                "boolean"
                  ? widgetGraphConfig?.chart_settings?.show_header
                  : true,
              chart_property: {
                chart_name: widgetGraphConfig?.chart_property?.chart_name,
                legend_position:
                  widgetGraphConfig?.chart_property?.legend_position,
                show_legend: widgetGraphConfig?.chart_property?.show_legend,
                y_axis_mode: widgetGraphConfig?.chart_property?.y_axis_mode,
                no_of_top_posts:
                  widgetGraphConfig?.chart_property?.no_of_top_posts,
              },
              show_marker: widgetGraphConfig?.show_marker,
              card_position: widgetGraphConfig?.card_position,
              card_limit: widgetGraphConfig?.card_limit,
              y_axes_settings: widgetGraphConfig?.y_axis_settings,
              cards_settings: card_settings_data ? card_settings_data : null,
              show_3d: widgetGraphConfig?.chart_settings?.show_3d,
              settings_3d: {
                alpha: widgetGraphConfig?.chart_settings?.settings_3d?.alpha,
                beta: widgetGraphConfig?.chart_settings?.settings_3d?.beta,
                depth: widgetGraphConfig?.chart_settings?.settings_3d?.depth,
              },
              show_peak: widgetGraphConfig?.chart_settings?.show_peak,
              show_valley: widgetGraphConfig?.chart_settings?.show_valley,
              show_horizontal_view:
                widgetGraphConfig?.chart_settings?.show_horizontal_view,
              chart_styles:
                widgetGraphConfig?.chart_settings?.chart_styles || null,
              cluster_style: widgetGraphConfig?.chart_settings?.cluster_style,
              cluster_chart_type:
                widgetGraphConfig?.chart_settings?.cluster_chart_type,
              total_count_flag:
                widgetGraphConfig?.chart_settings?.total_count_flag || false,
            },
          },
          widget_name: chartName
            ? chartName
            : widgetGraphConfig?.chart_property?.chart_name,
          widget_description: description,

          x_axis: widgetGraphConfig?.x_axis,
          y_axes:
            widgetGraphConfig?.breakdown_by?.length > 0
              ? widgetGraphConfig?.breakdown_by
              : widgetGraphConfig?.filter_by?.length > 0
              ? widgetGraphConfig?.filter_by
              : null,
          // for filter dropdown in widget header
          filter_dropdown:
            widgetGraphConfig?.filter_dropdown?.length > 0
              ? widgetGraphConfig?.filter_dropdown
              : [],
          order_by: updatedOrderBy ? updatedOrderBy : null,
          y_series: y_series_array,
          filters: widgetGraphConfig?.filters
            ? widgetGraphConfig?.filters
            : null,
          start_date: widgetGraphConfig?.duration?.from
            ? widgetGraphConfig?.duration?.from
            : defaultDuration?.from,
          end_date: widgetGraphConfig?.duration?.to
            ? widgetGraphConfig?.duration?.to
            : defaultDuration?.to,
          brands:
            widgetGraphConfig?.brands?.length > 0
              ? widgetGraphConfig?.brands
              : brandlogicalgroup?.length > 0
              ? brandlogicalgroup
              : brands,
          isBrandModified: widgetGraphConfig?.brands ? true : false,
          utcoffset: utcOffset,
          tags: widgetTag ? widgetTag : [],
          search_text: "",
          pill: widgetLibraryFilter?.pill
            ? widgetLibraryFilter?.pill
            : "All Widgets",
          offset: 0,
          no_of_rows: 12,
          sort_expression: "created_date",
          sort_order: "desc",
          chart_type: "",
          attribute: "",
          type: "widget-maker",
          relative_duration: relative_duration,
          multilevel_breakdown: widgetGraphConfig?.multilevel_breakdown || null,
        };
        // Check and update chart settings based on benchmark line case
        let updatedSaveObject =
          updateChartSettingsInGraphObjectBasedOnSelection({
            widgetGraphConfig: widgetGraphConfig,
            brandlogicalgroup: brandlogicalgroup,
            brands: brands,
            graphObject: saveObject,
          });
        if (updatedSaveObject) {
          saveObject = updatedSaveObject;
        }
        dispatch(setCreateWidget(saveObject, widget_obj));
        setVisible(false);
      }
    }
  };

  const handleChange = (e) => {
    setflag(true);
    dispatch(setWidgetChartName(e.target.value, widgetGraphConfig));
  };
  const handleDescription = (e) => {
    setdescription(e.target.value);
    // For Edit widget in dashboard
    dispatch(setWidgetChartDescription(e.target.value, widgetGraphConfig));
  };
  const handleBackButton = () => {
    let pathName = window.location.pathname?.split("/")?.[1];
    if (
      pathName === "dashboard" ||
      pathName === "pin-dashboard" ||
      pathName === "all-dashboard"
    ) {
      function compareObjects(obj1, obj2) {
        const areEqual = isEqual(obj1, obj2);

        if (areEqual) {
          // console.log("Objects are equal");
          // Close the Filter Drawer pannel
          dispatch(setisFilterPanelVisible(false));

          // console.log("panes on back", panes?.[index]);
          let section_index =
            panes?.[index]?.is_widget_maker_open_obj?.section_index;
          let widget_index =
            panes?.[index]?.is_widget_maker_open_obj?.widget_index;

          let updatePanes = [...panes];
          if (section_index >= 0) {
            // Make Brands null
            // updatePanes[index].sections[section_index].widgets[
            //   widget_index
            // ].brand_groups = null;
            // updatePanes[index].sections[section_index].widgets[
            //   widget_index
            // ].brand_ids = null;

            let obj = {
              open_flag: false,
              section_index: null,
              widget_index: null,
            };
            updatePanes[index].is_widget_maker_open_obj = obj;
            updatePanes[index].edited_widgetGraphConfig = null;
          } else {
            // Make Brands null
            // updatePanes[index].section[0].widgets[widget_index].brand_groups = null;
            // updatePanes[index].section[0].widgets[widget_index].brand_ids = null;

            let obj = {
              open_flag: false,
              section_index: null,
              widget_index: null,
            };
            updatePanes[index].is_widget_maker_open_obj = obj;
            updatePanes[index].edited_widgetGraphConfig = null;
          }

          // console.log("On Back updatePanes", updatePanes);
          dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });

          // Reset Widget GraphConfig
          dispatch(
            setY_attribute({
              x_axis: null,
              y_axis: {
                y_series_1: {
                  attribute: null,
                  aggregation: null,
                },
              },
              y_axis_settings: [],
              breakdown_by: [],
              filter_by: [],
              fields: [],
              chart_type: "line",
              duration: null,
              brands: null,
              filters: [],
              show_marker: true,
              card_position: "Top",
              card_limit: 5,
              card_settings: [
                {
                  card_id: uuid(),
                  card_name: 1,
                  card_value: null,
                  x_axis: null,
                  y_series: null,
                  response: [],
                },
              ],
              rich_fields_content: null,
              chart_settings: {
                global_data_label: false,
                show_details_on_card: false,
                is_stacked: true,
                data_count_card: true,
                duration_comparison: false, // This is used for only KPI
                show_previous_duration_comparison: false, // This is used for charts
                show_previous_duration_data: false, // This is used for charts
                show_as_median: false, // this is used for scatter chart
                card_percent: true,
                chart_percent: false,
                gradient_color: false,
                group_line_agg: null,
                benchmark_line: false,
                benchmark_static_value: null,
                duplicate_for_brands: false,
                split_cards: true,
                wordcloud_color: "0",
                top_posts_in_cards: false,
                show_header: true,
                show_peak: true,
                show_valley: true,
                chart_styles: null,
                cluster_style: null,
                cluster_chart_type: null,
                total_count_flag: false,
              },
              chart_property: {
                chart_name: null,
                legend_position: "bottom",
                show_legend: true,
                y_axis_mode: 2,
                no_of_top_posts: 1,
              },
              widget_description: null,
              dragDataType: {
                varchar: false,
                int: false,
                datetime: false,
                json: false,
              },
              edit_fields: {
                boolValue: false,
                series: "",
                data: "",
              },
              order_by: null,
              custom_attribute: {
                name: null,
                description: null,
                formula: null,
                custom_column: [
                  {
                    parameters: {
                      attribute: null,
                      display_name: null,
                      data_type: null,
                      selected: true,
                    },
                    operator: { value: null, selected: false },
                    pair: {
                      parameters: {
                        attribute: null,
                        display_name: null,
                        data_type: null,
                        selected: false,
                      },
                      numeric: { value: null, selected: false },
                    },
                    combined_operator: {
                      value: null,
                      selected: false,
                    },
                  },
                ],
              },
              widgetResetState: false,
              tags: [],
              filter_by_data: [],
              postcard_pills_filter: null,
              // for filter dropdown in widget header
              filter_dropdown: [],
              filter_by_dropdown: [],
              filter_by_dropdown_data: [],
              multilevel_breakdown: null,
            })
          );
        } else {
          // console.log("Objects are different");
          setOpenExitModal(true);
        }
      }
      compareObjects(
        widgetGraphConfig,
        panes?.[index]?.edited_widgetGraphConfig
      );
    } else {
      window.stop();

      let clearFilterData = filterData?.map((e) => {
        if (e?.is_searchable) {
          return { ...e, values: [] };
        }
        return { ...e };
      });
      dispatch(setFilterPanelData(clearFilterData));
      dispatch(setUpdateImpression(false));
      dispatch(setWidgetShow(false));
      dispatch(setEditWidget(false));
      dispatch(setWidgetPreview(null));
      dispatch(setWidgetPreviewLoader(false));
      dispatch(
        setX_attribute({
          x_axis: null,
          y_axis: {
            y_series_1: {
              attribute: null,
              aggregation: "COUNT",
            },
          },
          y_axis_settings: [],
          breakdown_by: [],
          fields: [],
          chart_type: "line",
          duration: null,
          brands: null,
          filters: null,
          show_marker: true,
          card_position: "Top",
          card_limit: 5,
          card_settings: [
            {
              card_id: uuid(),
              card_name: 1,
              card_value: null,
              x_axis: null,
              y_axis: null,
              response: [],
            },
          ],
          rich_fields_content: null,
          chart_settings: {
            global_data_label: false,
            show_details_on_card: false,
            show_3d: false,
            settings_3d: null,
            show_label_names: true,
            is_stacked: true,
            data_count_card: true,
            duration_comparison: false, // This is used for only KPI
            show_previous_duration_comparison: false, // This is used for charts
            show_previous_duration_data: false, // This is used for charts
            show_as_median: false, // this is used for scatter chart
            card_percent: true,
            card_percent: false,
            duplicate_for_brands: false,
            split_cards: true,
            top_posts_in_cards: false,
            show_header: true,
            wordcloud_color: "0",
            show_peak: true,
            show_valley: true,
            chart_styles: null,
            cluster_style: null,
            cluster_chart_type: null,
            total_count_flag: false,
          },
          chart_property: {
            chart_name: null,
            legend_position: "bottom",
            y_axis_mode: 2,
            no_of_top_posts: 1,
          },

          dragDataType: {
            varchar: false,
            int: false,
            datetime: false,
            json: false,
          },
          tags: [],
          multilevel_breakdown: null,
        })
      );
      dispatch(setIsDuplicate({ redirect: false, widget_id: null }));
      dispatch(setWidgetMakerGraphData(null));
      if (window.location.pathname === "/dashboard") {
        history.push("/dashboard");
      } else {
        history.push("/widgetMaker");
      }

      // Recall Widget List API
      let obj = {
        authParams: authParams,
      };
      let widgetLibraryListObject = getWidgetLibraryListObject(obj);

      authParams && dispatch(setWidgetLibraryList(widgetLibraryListObject));

      let filterObj = {
        search_text: "",
        pill: "All Widgets",
        offset: 0,
        no_of_rows: 12,
        sort_expression: "created_date",
        sort_order: "desc",
        chart_type: "",
        attribute: "",
      };
      dispatch(setWidgetLibraryFilter(filterObj));
    }
  };

  const onTagAdded = (tag, text, tagsList) => {
    if (text?.[0]?.trim()?.length > 0) {
      if (tag && widgetTag?.indexOf(tag) === -1) {
        dispatch(setWidgetTags(tag, widgetGraphConfig));
      }
    }
  };

  return (
    <>
      {openAlertModal && (
        <AlertModal
          visible={openAlertModal}
          setVisible={setOpenAlertModal}
          description={description}
        />
      )}

      {/* For Edit Widget in Dashboard */}
      {openExitModal && (
        <ExitModal visible={openExitModal} setVisible={setOpenExitModal} />
      )}

      <PageHeader
        className="bg-white text-Darkgray border-bottom border-color"
        title={
          <div className="d-flex align-items-center justify-content-between ">
            <span
              onClick={() => handleBackButton()}
              className={`text_heading fontSize-16 d-inline-flex align-items-center cursor-pointer`}
            >
              <img
                src={
                  authParams?.theme_type === "1" ? BackArrowWhite : BackArrow
                }
                alt="Back arrow"
                style={{ maxWidth: "2rem" }}
                className="mr-1"
              />
              {isEditWidget ? "Edit Widget" : "Create a Widget"}
            </span>
            <div>
              <Button className="btn_Clear mr-15" onClick={handleBackButton}>
                Cancel
              </Button>

              <Popover
                placement="bottomLeft"
                content={
                  <div
                    style={{
                      right: "-11rem",
                    }}
                    className="position-absolute box-shadow border-radius-8 bg-white p-15 box-shadow bg-white "
                  >
                    <div className="d-flex justify-content-between">
                      <div style={{ minWidth: "27.5rem" }}>
                        <div className="text_heading text-transform__capitalize font-weight600 mb-15">
                          Enter details to save widget
                        </div>
                        <div className="position-relative mb-15 floating-label-group header-brands">
                          <Input
                            showCount={false}
                            id="outlined-required"
                            maxLength={100}
                            InputLabelProps={{
                              shrink:
                                chartName && chartName?.trim().length > 0
                                  ? true
                                  : false,
                            }}
                            value={chartName}
                            error={flag && chartName?.trim()?.length === 0}
                            helperText={
                              flag &&
                              chartName?.trim()?.length === 0 && (
                                <span className="error">
                                  Widget name cannot be empty *
                                </span>
                              )
                            }
                            placeholder={"Enter Widget Name"}
                            className="border-radius-4"
                            onChange={(e) => handleChange(e)}
                          />
                          <label className="portlet-label floating-label">
                            Widget Name <span className="error">*</span>
                          </label>
                          <span
                            className="text-gray position-absolute font-size12"
                            style={{
                              right: "0.3rem",
                              bottom: "0rem",
                            }}
                          >
                            {chartName?.length > 0 ? chartName?.length : "0"}
                            /100
                          </span>
                        </div>
                        <div className="position-relative bg-white mt-15">
                          <div className="mb-15 w-100 TagList InputPills floating-label-group">
                            <TagsInput
                              value={widgetTag ? widgetTag : []}
                              onChange={(e, text) =>
                                onTagAdded(e, text, widgetTag)
                              }
                              style={{
                                all: "unset",
                              }}
                              inputProps={{
                                disabled: widgetTag?.length >= 3 ? true : false,
                                placeholder:
                                  widgetTag?.length >= 3 ? "" : "Add a tag",
                                className:
                                  widgetTag?.length >= 3
                                    ? "react-tagsinput-input d-none"
                                    : "react-tagsinput-input",
                              }}
                              maxTags={3}
                            />
                            <label className="category__name floating-label">
                              Tags
                            </label>
                          </div>
                        </div>

                        <div className="position-relative mb-15 floating-label-group header-brands">
                          <TextArea
                            rows={5}
                            id="outlined-required"
                            multiline
                            className="border-radius-4 border-color"
                            maxLength={150}
                            value={description}
                            onChange={(e) => handleDescription(e)}
                            style={{ resize: "none", padding: "0.8rem 1rem" }}
                            placeholder={"Enter Description"}
                          />
                          <label className="portlet-label floating-label">
                            Description
                          </label>
                          <span
                            className="text-gray position-absolute font-size12"
                            style={{
                              right: "0.2rem",
                              bottom: "0.1rem",
                            }}
                          >
                            {description?.length > 0
                              ? description?.length
                              : "0"}
                            /150
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="text-right">
                      <Button
                        type="button"
                        className="btn_Clear mr-15"
                        onClick={() => {
                          setVisible(false);
                          setflag(false);
                          setWidgetName("");
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="primary"
                        className="ant-btn-primary_blue"
                        style={{
                          pointerEvents: chartLoader
                            ? "none"
                            : !enableSave
                            ? "none"
                            : chartName === null
                            ? "none"
                            : chartName?.trim().length === 0
                            ? "none"
                            : "auto",
                          opacity: chartLoader
                            ? "0.5"
                            : !enableSave
                            ? "0.5"
                            : chartName === null
                            ? "0.5"
                            : chartName?.trim().length === 0
                            ? "0.5"
                            : "1",
                        }}
                        onClick={() => handleSaveWidget()}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                }
                title={null}
                trigger="click"
                visible={visible}
                overlayClassName={
                  authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                }
              >
                <Button
                  type="primary"
                  className="ant-btn-primary_blue"
                  onClick={() => {
                    setVisible(true);
                    if (
                      !flag &&
                      widgetGraphConfig?.chart_property?.chart_name?.trim()
                        ?.length != 0
                    ) {
                      setWidgetName(
                        widgetGraphConfig?.chart_property?.chart_name
                      );
                    } else {
                      setWidgetName("");
                    }
                  }}
                >
                  {isEditWidget ? "Save Widget" : "Save Widget"}
                </Button>
              </Popover>
            </div>
          </div>
        }
        style={{
          padding: "0.8rem 1.5rem",
        }}
      />
    </>
  );
};

export default WidgetMakerHeader;
